<div *ngIf="shouldShow" class="env-badge-container ml-4">
    <!-- the badge; on a local setup with test tenants it is also the TEST-ONLY "view as tenant" button -->
    <button type="button" class="env-badge env-blink-effect" [ngClass]="badgeClass" [class.env-btn]="testTenants.length > 0"
            [disabled]="!testTenants.length" [attr.aria-haspopup]="testTenants.length ? 'menu' : null" [attr.aria-expanded]="menuOpen"
            [title]="testTenants.length ? 'Dashboard: view as tenant (test only)' : ''" (click)="toggleMenu($event)">
        <i class="flaticon2-layers text-white"></i>
        <span>{{ envName }}</span>
        <ng-container *ngIf="testTenants.length">
            <span class="env-as">· {{ viewAs.tenantId || 'me' }}</span>
            <svg class="env-chev" viewBox="0 0 12 12" aria-hidden="true"><path d="M3 4.5l3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
        </ng-container>
    </button>
    <div class="env-menu" *ngIf="menuOpen" role="menu" aria-label="View dashboard as (test only)" (click)="$event.stopPropagation()">
        <div class="env-menu-h">Dashboard as (test only)</div>
        <button type="button" role="menuitemradio" [attr.aria-checked]="!viewAs.tenantId" [class.on]="!viewAs.tenantId" (click)="pick(null)">my tenant</button>
        <button type="button" role="menuitemradio" *ngFor="let t of testTenants" [attr.aria-checked]="viewAs.tenantId === t.tenantId"
                [class.on]="viewAs.tenantId === t.tenantId" (click)="pick(t.tenantId)">
            {{ t.tenantId }} · {{ t.tenancyName }} <small>(prod {{ t.sourceTenantId }})</small>
        </button>
    </div>
</div>
